import Vue from 'vue'
import Auth from '@okta/okta-vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

const CALLBACK_PATH = '/implicit/callback'

const config = {
  issuer: process.env.VUE_APP_OKTA_URL + '/oauth2/default',
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri: process.env.VUE_APP_HOME_URL + CALLBACK_PATH,
  scope: 'openid profile email',
};

Vue.use(Auth, {...config})

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: CALLBACK_PATH,
    component: Auth.handleCallback()
  },
  {
    path: '/tm28ryy',
    name: 'TM28RYY',
    component: () => import(/* webpackChunkName: "tm28ryy" */ '../components/tm28ryy.vue'),
    //meta: { requiresAuth: true }
  },
  {
    path: '/tm37fug',
    name: 'TM37FUG',
    component: () => import(/* webpackChunkName: "tm37fug" */ '../components/tm37fug.vue'),
    //meta: { requiresAuth: true }
  },
  {
    path: '/:vehicleId',
    name: 'Vehicle',
    component: () => import(/* webpackChunkName: "vehicle" */ '../components/VehicleRoute.vue'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

export default router
